import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "absolute top-2 right-14" }
const _hoisted_2 = {
  key: 0,
  class: "fixed visible group-hover:invisible"
}

import { useI18n } from 'vue-i18n';
	import { useRouter } from 'vue-router';
	import { Room, useRooms, useDialog } from '@/store/store';
	import { usePubHubs } from '@/core/pubhubsStore';
	import { RoomType } from '@/store/rooms';
	import { usePlugins, PluginProperties } from '@/store/plugins';
	import { useToggleMenu } from '@/store/toggleGlobalMenu';
	import { NotificationCountType } from 'matrix-js-sdk';
	import { useSettings, featureFlagType } from '@/store/store';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomList',
  props: {
		roomType: {
			type: String,
			default: '!' + RoomType.PH_MESSAGES_DM,
		},
	},
  setup(__props) {

	const settings = useSettings();

	const { t } = useI18n();
	const router = useRouter();
	const rooms = useRooms();
	const pubhubs = usePubHubs();
	const plugins = usePlugins();
	const toggleMenu = useToggleMenu();

	const props = __props;

	function showRoom(room: Room): Boolean {
		if (room.isHidden()) {
			return false;
		}
		if (props.roomType !== '') {
			const type = props.roomType.substring(1);
			if (props.roomType.charAt(0) === '!') {
				return room.getType() !== type;
			} else {
				return room.getType() === props.roomType;
			}
		}
		return true;
	}

	async function leaveRoom(roomId: string) {
		const room = rooms.room(roomId);
		if (room) {
			const dialog = useDialog();
			if (await dialog.okcancel(t('rooms.leave_sure'))) {
				await pubhubs.leaveRoom(roomId);
				await router.replace({ name: 'home' });
			}
		}
	}

	function roomIcon(room: Room): string {
		let icon = 'room';
		const plugin = plugins.hasRoomPlugin(room) as PluginProperties;
		if (plugin.icon) {
			icon = plugin.icon;
		}
		return icon;
	}

return (_ctx: any,_cache: any) => {
  const _component_InlineSpinner = _resolveComponent("InlineSpinner")!
  const _component_PrivateRoomName = _resolveComponent("PrivateRoomName")!
  const _component_RoomName = _resolveComponent("RoomName")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_UnreadMessageBadge = _resolveComponent("UnreadMessageBadge")!
  const _component_UnreadMentionBadge = _resolveComponent("UnreadMentionBadge")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, null, {
    default: _withCtx(() => [
      (!_unref(rooms).roomsLoaded)
        ? (_openBlock(), _createBlock(_component_InlineSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(rooms).hasRooms)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(rooms).sortedRoomsArray, (room) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: room.roomId
            }, [
              (showRoom(room))
                ? (_openBlock(), _createElementBlock("div", {
                    key: room.roomId,
                    class: "group",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleMenu).toggleGlobalMenu()))
                  }, [
                    _createVNode(_component_router_link, {
                      to: { name: 'room', params: { id: room.roomId } }
                    }, {
                      default: _withCtx(({ isActive }) => [
                        (_openBlock(), _createBlock(_component_MenuItem, {
                          roomInfo: room,
                          icon: roomIcon(room),
                          active: isActive,
                          key: room.roomId,
                          class: "relative"
                        }, {
                          default: _withCtx(() => [
                            (room.isPrivateRoom())
                              ? (_openBlock(), _createBlock(_component_PrivateRoomName, {
                                  key: 0,
                                  members: room.getOtherJoinedAndInvitedMembers()
                                }, null, 8, ["members"]))
                              : (_openBlock(), _createBlock(_component_RoomName, {
                                  key: 1,
                                  room: room
                                }, null, 8, ["room"])),
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(_component_Icon, {
                                type: "unlink",
                                class: "fixed cursor-pointer invisible hover:text-red group-hover:visible",
                                onClick: _withModifiers(($event: any) => (leaveRoom(room.roomId)), ["prevent"])
                              }, null, 8, ["onClick"]),
                              (_unref(settings).isFeatureEnabled(_unref(featureFlagType).notifications))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    (room.getRoomUnreadNotificationCount(_unref(NotificationCountType).Total) > 0)
                                      ? (_openBlock(), _createBlock(_component_UnreadMessageBadge, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(room.getRoomUnreadNotificationCount(_unref(NotificationCountType).Total)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    (room.getRoomUnreadNotificationCount(_unref(NotificationCountType).Highlight) > 0)
                                      ? (_openBlock(), _createBlock(_component_UnreadMentionBadge, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(room.getRoomUnreadNotificationCount(_unref(NotificationCountType).Highlight)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["roomInfo", "icon", "active"]))
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})